import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB4nx04aXs2m3hQKfFS1JucXM5B8TKN8Ow",
  authDomain: "monopoly-6d411.firebaseapp.com",
  databaseURL: "https://monopoly-6d411-default-rtdb.firebaseio.com",
  projectId: "monopoly-6d411",
  storageBucket: "monopoly-6d411.firebasestorage.app",
  messagingSenderId: "638152137085",
  appId: "1:638152137085:web:51c3dee9858210d162d414"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
